import React, { useState } from 'react'
import { Collapse, Slider, Select, Button } from 'antd';

const { Option } = Select;
const { Panel } = Collapse;


const priceMarks = {
    2: {
        style: {
            color: '#6b46c1',
        },
    label: <strong>2</strong>,
    },
    5: '5',
    12: '12',
    20: {
        style: {
          color: '#6b46c1',
        },
        label: <strong>20</strong>,
      },
  };
  const hpMarks = {
    10: {
        style: {
            color: '#6b46c1',
        },
    label: <strong>10</strong>,
    },
    38: '38',
    65: '65',
    93: '93',
    120: {
        style: {
          color: '#6b46c1',
        },
        label: <strong>120</strong>,
      },
  }

  const wheelDriveList = ["2WD", "4WD"]
  
  const brandList = ["mahindra", "john deere", "solnalika", "farmtrac", "new holland", "swaraj"]


function TractorFilter() {
    const [priceRange, setPriceRange] = useState([2, 12])
    const [hpRange, setHpRange] = useState([15, 55])
    const [wheelDrive, setWheelDrive] = useState([])
    const [brand, setBrand] = useState([])
    
    const onPriceRangeChange = (values) => console.log(values)

    const onHpRangeChange = (values) => console.log(values)
    const onWheelDriveChange = (event) => console.log(event)
    const onBrandChange = (event) => console.log(event)

  return (
    <div>
        <p className="px-6 py-3 flex justify-between text-xl font-bold tracking-wide border-b">
            <div className="flex items-center text-gray-600">
                <svg className="h-5 w-5 fill-current" viewBox="0 0 20 20"><path fill-rule="evenodd" d="M3 3a1 1 0 011-1h12a1 1 0 011 1v3a1 1 0 01-.293.707L12 11.414V15a1 1 0 01-.293.707l-2 2A1 1 0 018 17v-5.586L3.293 6.707A1 1 0 013 6V3z" clip-rule="evenodd"></path></svg>
                &nbsp;Filter
            </div>
            <span className="right">
                <Button type="dashed">Reset</Button>
            </span>
        </p>
        <div className="">
            <Collapse defaultActiveKey={['1', '2', '3', '4']} expandIconPosition="right" >
                <Panel header={
                        <div className="flex items-center">
                            <p className="text-lg ml-2">Price </p>
                            {/* <span className="text-xs ml-1">(in Lacs)</span> */}
                        </div>
                    } key="1">
                    <Slider
                        min={2} 
                        max={20}
                        value={priceRange}
                        marks={priceMarks}
                        range 
                        // tooltipVisible
                        autoFocus
                        tipFormatter={(x) => `₹${x}Lakh`}
                        className="mx-3"
                        onAfterChange={onPriceRangeChange}
                        onChange={setPriceRange}
                        />
                </Panel>
                <Panel header={
                        <div className="flex items-center">
                            <p className="text-lg ml-2">HP </p>
                        </div>
                    } key="2">
                        <Slider
                            min={10} 
                            max={120}
                            // defaultValue={[2, 12]} 
                            value={hpRange}
                            marks={hpMarks}
                            range 
                            // tooltipVisible
                            tipFormatter={(x) => `${x}HP`}
                            className="mx-3"
                            onAfterChange={onHpRangeChange}
                            onChange={setHpRange}
                            />
                </Panel>
                <Panel header={
                        <div className="flex items-center">
                            <p className="text-lg ml-2">Wheel drive</p>
                        </div>
                    } key="3">
                    <Select
                        mode="multiple"
                        className="w-full my-2"
                        placeholder="Wheel drive"
                        value={wheelDrive}
                        onChange={setWheelDrive}
                        optionLabelProp="label"
                        onSelect={onWheelDriveChange}
                        showSearch
                        showArrow
                        >
                        {wheelDriveList.map((value, key) => (
                            <Option value={value} label={value} key={key}>
                                {value}
                            </Option>
                        ))}
                    </Select>
                </Panel>
                <Panel header={
                        <div className="flex items-center">
                            <p className="text-lg ml-2">Brand</p>
                        </div>
                    } key="4">
                    <Select
                        mode="multiple"
                        className="w-full my-2"
                        placeholder="Wheel drive"
                        value={brand}
                        onChange={setBrand}
                        optionLabelProp="label"
                        onSelect={onBrandChange}
                        showSearch
                        showArrow
                        >
                        {brandList.map((value, key) => (
                            <Option value={value} key={key}>
                                {value.toUpperCase()}
                            </Option>
                        ))}
                    </Select>
                </Panel>
            </Collapse>
        </div>



    </div>
  );
}

export default TractorFilter;
